import { Attitude } from '../entities/attitude';

export default [
  { value: Attitude.Positive, text: "positiv" },
  { value: Attitude.Neutral, text: "neutral" },
  { value: Attitude.Negative, text: "negativ" },
]
